import { logEvent } from "firebase/analytics"
import Vue from "vue"
import lodash from "lodash"

let inProgressFetchControllers = {}

async function apiRequest(httpMethod, apiMethod, queryParams, requestParams, abortInProgressRequest) {
	try {
		// Check if there is already an in-progress fetch for this apiMethod and abortInProgressRequest is true
		if (inProgressFetchControllers[apiMethod] && abortInProgressRequest) {
			// Abort the previous request and remove its entry from the in-progress fetches object
			inProgressFetchControllers[apiMethod].abort()
			delete inProgressFetchControllers[apiMethod]
		}
		// Create a new AbortController for this request
		const fetchController = new AbortController()
		inProgressFetchControllers[apiMethod] = fetchController

		if (queryParams) {
			queryParams = lodash.omitBy(queryParams, lodash.isNil)
			const queryString = new URLSearchParams(queryParams)
			apiMethod += `?${queryString}`
		}
		var endPoint = "./api/" + apiMethod
		logEvent(Vue.prototype.$analytics, "apiRequest:" + apiMethod)
		const request = await fetch(endPoint, {
			method: httpMethod,
			headers: {
				"Content-Type": "application/json",
			},
			body: requestParams && JSON.stringify(requestParams),
			signal: fetchController.signal,
		})

		// On request completed, remove the entry for this request from the in-progress fetches object
		delete inProgressFetchControllers[apiMethod]

		if (request.status === 403) {
			window.location.href = "/login.html"
		}

		if (!request.ok) {
			throw Error(request.statusText)
		}

		const response = await request.json()
		if (response.err && response.err.errno == 401) {
			alert("Your current device is logged out as you have logged in from another device. Please login again")
			window.location.href = "/login.html"
		}
		response.status = response.err ? "error" : "success"

		return response
	} catch (error) {
		console.log(error)
		if (error.message == "Failed to fetch") {
			return { err: "Failed to fetch", response: null, status: "error" }
		}
		if (error.name === "AbortError") {
			return {
				err: "The fetch request was aborted",
				response: null,
				status: "error",
				abortedInProgressRequest: true,
			}
		}
		logEvent(Vue.prototype.$analytics, "exception", { data: JSON.stringify(error) })
		return {
			err: JSON.stringify(error, Object.getOwnPropertyNames(error)),
			response: null,
			status: "error",
		}
	}
}

export default async function (apiMethod, requestParams, abortInProgressRequest) {
	return apiRequest("POST", apiMethod, undefined, requestParams, abortInProgressRequest)
}

export async function getApi(endpoint, queryParams) {
	return await apiRequest("GET", endpoint, queryParams)
}
